import { render, staticRenderFns } from "./exercisegroupmatchlist.vue?vue&type=template&id=21a740a0&scoped=true"
import script from "./exercisegroupmatchlist.vue?vue&type=script&lang=js"
export * from "./exercisegroupmatchlist.vue?vue&type=script&lang=js"
import style0 from "./exercisegroupmatchlist.vue?vue&type=style&index=0&id=21a740a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a740a0",
  null
  
)

export default component.exports